import React, { useState, useEffect } from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import './OnlineQuranClassesInNewyork.css';
import { submitForm } from '../utils/formSubmit';
import Swal from 'sweetalert2';

const tutorsData = [
  {
    name: 'Qaria Sadaf Sarfaraz',
    role: 'Islamic Scholar',
    description: 'Highest satisfaction rate in first class most student',
    image: 'tutor-yousra.jpeg',
    profileUrl: '/our-tutors/qaria-sadaf-sarfaraz/'
  },
  {
    name: 'Molana Hafiz Qari Osama Hussein',
    role: 'Islamic scholar',
    description: 'Specialization in Islamic studies of Seeratun Nabi (S.A.W)',
    image: 'tutor-osama.jpg',
    profileUrl: '/our-tutors/molana-hafiz-qari-osama-hussein/'
  },
  {
    name: 'Molana Hafiz Kaleem Ullah',
    role: 'Islamic scholar',
    description: 'Specialization in Islamic studies of Seeratun Nabi (S.A.W)',
    image: 'tutor-kaleem.jpg',
    profileUrl: '/our-tutors/molana-hafiz-kaleem-ullah/'
  },
  {
    name: 'Aalima Qaria Yousra',
    role: 'Islamic Scholar',
    description: 'Highest satisfaction rate in first class most student',
    image: 'tutor-sadaf.jpeg',
    profileUrl: '/our-tutors/aalima-qaria-yousra/'
  }
];

const CaliforniaLeftFAQs = [
  {
    id: 'tx-left-0',
    question: 'Are your Online Quran classes in California suitable for beginners?',
    answer: 'Yes. Our beginner courses cover Noorani Qaida, Quran reading, and foundational Tajweed rules.'
  },
  {
    id: 'tx-left-1',
    question: 'Do you offer Online Quran classes for kids in California?',
    answer: 'Yes. We provide specialized courses and Quran lessons for kids in California, taught by experienced instructors.'
  },
  {
    id: 'tx-left-2',
    question: 'Can adults join your classes?',
    answer: 'Yes. Our online Quran classes are designed for adults as well as children. Adult learners can enroll in Quran reading, Tajweed, Hifz, Islamic studies, and an Arabic language course.'
  },
  {
    id: 'tx-left-3',
    question: 'What makes Al Quran Lesson different from other online Quran academies?',
    answer: 'We offer Ijazah-certified teachers, affordable pricing, soft notes & PDF materials, Islamic Studies, and a 3-day free trial, all in one place.'
  },
];

const CaliforniaRightFAQs = [
  {
    id: 'tx-right-0',
    question: 'Do you have male and female teachers?',
    answer: 'Yes. We offer both male and female Quran teachers so students and parents can choose an instructor based on their comfort and learning preferences.'
  },
  {
    id: 'tx-right-1',
    question: 'What will the students learn in Tajweed classes?',
    answer: (<>
      Students learn how to pronounce correctly, Makharij, and recite the Quran in our <a style={{ color: "#006100" }} href="/online-tajweed-classes-tajweed-course/">online Tajweed course</a> in California.</>)
  },
  {
    id: 'tx-right-2',
    question: 'Are the classes individual or in groups?',
    answer: 'We offer both individualized and group sessions. One-on-One Quran classes online are the primary method we use during our tajweed classes.'
  },
  {
    id: 'tx-right-3',
    question: 'Do you offer Online Hifz Classes in California?',
    answer: (<> Yes. Our <a style={{ color: "#006100" }} href="/quran-memorization-classes-course/">Online Hifz Classes</a> in California are designed for students who want to memorize the Holy Quran under the supervision of qualified Huffaz.</>)
  },
  {
    id: 'tx-right-4',
    question: 'What are the available class timings?',
    answer: 'We offer classes 7 days a week, flexible according to (PST) timing, morning, evening, and weekend slots available.'
  },
  {
    id: 'tx-right-5',
    question: 'Is there any free trial?',
    answer: (<> Yes, Simply fill out our <a style={{ color: "#006100" }} href="/free-trial/">free trial</a> form or call us at <a style={{ color: "#006100" }} href="tel:+17164577657">(716) 457-7657</a> or email us at <a style={{ color: "#006100" }} href="mailto:info@alquranlesson.com">info@alquranlesson.com</a></>)
  },
  {
    id: 'tx-right-6',
    question: 'Do you offer anything beyond Quran classes?',
    answer: 'Yes, we also offer Islamic Studies, daily Duas, and career-building programs for children alongside all Quran courses.'
  },
];

const OnlineQuranClassesCalifornia = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    message: ''
  });

  const [openFaqId, setOpenFaqId] = useState(null);

  const toggleCaliforniaFAQ = (id) => {
    setOpenFaqId(prevId => (prevId === id ? null : id));
  };

  const [assessmentData, setAssessmentData] = useState({
    firstName: '',
    lastName: '',
    course: 'Noorani Qaida',
    country: '',
    phone: '',
    message: ''
  });

  const handleAssessmentChange = (e) => {
    const { name, value } = e.target;
    setAssessmentData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleAssessmentSubmit = async (e) => {
    e.preventDefault();
    if (!assessmentData.firstName || !assessmentData.lastName || !assessmentData.course || !assessmentData.country || assessmentData.country === 'Country' || !assessmentData.phone || !assessmentData.message) {
      Swal.fire({
        title: 'All Fields Required',
        text: 'Please fill in all fields including Country and Message.',
        icon: 'warning',
        confirmButtonColor: '#5c9456'
      });
      return;
    }
    try {
      await submitForm('California Assessment Form', assessmentData);
      Swal.fire({
        title: 'Success!',
        text: `Thank you, ${assessmentData.firstName}! Your free trial request has been submitted.`,
        icon: 'success',
        confirmButtonColor: '#5c9456'
      });
      setAssessmentData({
        firstName: '',
        lastName: '',
        course: 'Noorani Qaida',
        country: '',
        phone: '',
        message: ''
      });
    } catch (error) {
      Swal.fire({
        title: 'Error!',
        text: 'Failed to submit form. Please try again.',
        icon: 'error',
        confirmButtonColor: '#5c9456'
      });
    }
  };

  // Animated counters state
  const [experience, setExperience] = useState(0);
  const [students, setStudents] = useState(0);
  const [tutors, setTutors] = useState(0);

  // FAQ active state mapping (all closed by default)
  const [activeFaqs, setActiveFaqs] = useState({});

  const toggleFaq = (index) => {
    setActiveFaqs(prev => {
      const isOpen = prev[index];
      return isOpen ? {} : { [index]: true };
    });
  };

  // Testimonials Slider State
  const [currentSlide, setCurrentSlide] = useState(0);
  const testimonials = [
    {
      text: "I was concerned about my childâ€™s religious education, and now I am very pleased to see that they offer Quran classes in California. They have very nice and skilled tutors, and the ability to attend classes without disturbing school commitments was a huge bonus.",
      author: "Aisha - Houston"
    },
    {
      text: "I joined their online Quran with Tajweed classes in California. The teachers are professional, and the individual attention and support that I received during the Tajweed classes were excellent. The one-on-one lessons are very helpful to correct minor mistakes quickly.",
      author: "Yusuf - Dallas"
    },
    {
      text: "My children look forward to their classes and love to learn because of the knowledgeable and supportive Quran education their teachers provide. I highly recommend The Quran Academy California for anyone looking for Quran teachers near me in California.",
      author: "Mariam - Austin"
    },
    {
      text: "I was looking for Quran teachers near me in California, and then I enrolled there. From the free trial to regular classes, everything has been smooth. The tutors focus on real progress. One of the best platforms for online Quran classes for kids in California.",
      author: "Ibrahim - San Antonio"
    }
  ];

  // Auto-play timer for testimonials (5 seconds)
  useEffect(() => {
    const slideTimer = setInterval(() => {
      setCurrentSlide(prev => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(slideTimer);
  }, [testimonials.length]);

  const nextSlide = () => {
    setCurrentSlide(prev => (prev + 1) % testimonials.length);
  };

  const prevSlide = () => {
    setCurrentSlide(prev => (prev - 1 + testimonials.length) % testimonials.length);
  };

  // Contact Form State
  const [contactData, setContactData] = useState({
    firstName: '',
    lastName: '',
    phone: '',
    country: '',
    course: '',
    message: '',
    consent: false
  });

  const handleContactChange = (e) => {
    const { name, value, type, checked } = e.target;
    setContactData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleContactSubmit = async (e) => {
    e.preventDefault();
    if (!contactData.consent) {
      Swal.fire({
        title: 'Consent Required',
        text: "Please consent to terms to proceed.",
        icon: 'warning',
        confirmButtonColor: '#5c9456'
      });
      return;
    }
    try {
      await submitForm('California Contact Form', contactData);
      Swal.fire({
        title: 'Success!',
        text: `Thank you, ${contactData.firstName} ${contactData.lastName}! We have received your message.`,
        icon: 'success',
        confirmButtonColor: '#5c9456'
      });
      setContactData({
        firstName: '',
        lastName: '',
        phone: '',
        country: '',
        course: '',
        message: '',
        consent: false
      });
    } catch (error) {
      Swal.fire({
        title: 'Error!',
        text: 'Failed to submit form. Please try again.',
        icon: 'error',
        confirmButtonColor: '#5c9456'
      });
    }
  };

  useEffect(() => {
    // Load Calendly widget script dynamically
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Clean up script on unmount
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  useEffect(() => {
    // Load Google reCAPTCHA v2 API script dynamically if not already loaded
    const scriptId = 'google-recaptcha-script';
    if (!document.getElementById(scriptId)) {
      const script = document.createElement('script');
      script.id = scriptId;
      script.src = 'https://www.google.com/recaptcha/api.js';
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);
    }

    // Experience counter (0 to 13)
    let expStart = 0;
    const expEnd = 13;
    const expDuration = 1200; // ms
    const expStepTime = Math.max(Math.floor(expDuration / expEnd), 15);
    const expTimer = setInterval(() => {
      expStart += 1;
      setExperience(expStart);
      if (expStart >= expEnd) {
        clearInterval(expTimer);
      }
    }, expStepTime);

    // Tutors counter (0 to 20)
    let tutorsStart = 0;
    const tutorsEnd = 20;
    const tutorsDuration = 1200; // ms
    const tutorsStep = 1;
    const tutorsStepTime = Math.max(Math.floor(tutorsDuration / (tutorsEnd / tutorsStep)), 15);
    const tutorsTimer = setInterval(() => {
      tutorsStart += tutorsStep;
      setTutors(tutorsStart);
      if (tutorsStart >= tutorsEnd) {
        clearInterval(tutorsTimer);
      }
    }, tutorsStepTime);

    // Students counter (0 to 5000)
    let studentsStart = 0;
    const studentsEnd = 5000;
    const studentsDuration = 1200; // ms
    const studentsStep = 100;
    const studentsStepTime = Math.max(Math.floor(studentsDuration / (studentsEnd / studentsStep)), 15);
    const studentsTimer = setInterval(() => {
      studentsStart += studentsStep;
      setStudents(studentsStart);
      if (studentsStart >= studentsEnd) {
        clearInterval(studentsTimer);
      }
    }, studentsStepTime);

    return () => {
      clearInterval(expTimer);
      clearInterval(tutorsTimer);
      clearInterval(studentsTimer);
    };
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await submitForm('California Registration Form', formData);
      Swal.fire({
        title: 'Success!',
        text: `Thank you, ${formData.name}! Your request has been sent successfully. We will contact you soon.`,
        icon: 'success',
        confirmButtonColor: '#5c9456'
      });
      setFormData({ name: '', phone: '', message: '' });
    } catch (error) {
      Swal.fire({
        title: 'Error!',
        text: 'Failed to submit form. Please try again.',
        icon: 'error',
        confirmButtonColor: '#5c9456'
      });
    }
  };

  return (
    <div className="ny-page-wrapper">
      {/* Hero Section */}
      <section
        className="ny-hero"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.65), rgba(0, 0, 0, 0.65)), url('${process.env.PUBLIC_URL}/assets/images/online-quran-classes-texas/hero-texas.jpg')`
        }}
      >
        <div className="ny-hero__container">
          {/* Left Column: Heading, description, and stats */}
          <div className="ny-hero__content">
            <h1 className="ny-hero__title">
              <span className="ny-hero__title--highlight" style={{ marginBottom: '8px' }}>Online Quran Classes in California |</span>
              <span className="ny-hero__title--main"> The Best Online Quran Academy in California</span>
            </h1>
            <p className="ny-hero__desc">
              Al Quran Lesson offers Holy Quran classes online for the students of California. In these classes, students receive interactive sessions with a personal tutor who helps students with effective and systematic Quran learning. We offer multiple courses from <a style={{ color: "#006100" }} href="/noorani-qaida-course/">Noorani Qaida</a> to <a style={{ color: "#006100" }} href="/online-tajweed-classes-tajweed-course/">Quran Tajweed</a> and <a style={{ color: "#006100" }} href="/quran-memorization-classes-course/">Quran memorization</a>. You can join any of the classes as per your schedule and time zone from our interactive online virtual system. Try our free trial lesson, where each new student gets the proper attention from our certified Quran tutors.
            </p>

            {/* Stats list */}
            <div className="ny-hero__stats">
              <div className="ny-stat-item">
                <span className="ny-stat-value">{experience} +</span>
                <span className="ny-stat-label">Years Of Experience</span>
              </div>
              <div className="ny-stat-item">
                <span className="ny-stat-value">{students.toLocaleString()} +</span>
                <span className="ny-stat-label">Students Studied</span>
              </div>
              <div className="ny-stat-item">
                <span className="ny-stat-value">{tutors}+</span>
                <span className="ny-stat-label">Expert Tutors</span>
              </div>
            </div>
          </div>

          {/* Right Column: Sign Up Form Card */}
          <div className="ny-hero__form-card">
            <div className="ny-form-header">
              <h4 className="ny-form-title">Sign Up</h4>
              <h4 className="ny-form-subtitle">To Claim Your Free Trial</h4>
            </div>

            <form onSubmit={handleSubmit} className="ny-form">
              <div className="ny-form-row">
                <div className="ny-form-group">
                  <input
                    type="text"
                    name="name"
                    placeholder="Name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className="ny-form-input"
                  />
                </div>
                <div className="ny-form-group">
                  <input
                    type="tel"
                    name="phone"
                    placeholder="Phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                    className="ny-form-input"
                  />
                </div>
              </div>

              <div className="ny-form-group">
                <textarea
                  name="message"
                  placeholder="Message"
                  value={formData.message}
                  onChange={handleChange}
                  className="ny-form-textarea"
                />
              </div>

              {/* reCAPTCHA integration */}
              <div className="ny-recaptcha-container">
                <div
                  className="g-recaptcha"
                  data-sitekey={
                    window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
                      ? '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI' // Public Google test key for localhost development
                      : '6LdiHz4tAAAAAONg4UJVDRkG1K3enavhCUQbnmLx' // Production key for alquranlesson.com
                  }
                ></div>
              </div>

              <button type="submit" className="ny-form-submit-btn">
                Claim Free Trial
              </button>
            </form>
          </div>
        </div>
      </section>

      {/* Three Highlights Section */}
      <section className="ny-highlights-section">
        <div className="ny-highlights-container">
          {/* Card 1: Free 3-Day Trial */}
          <div className="ny-highlight-card">
            <div className="ny-highlight-icon-box">
              <svg className="ny-highlight-icon-svg" viewBox="0 0 576 512" fill="currentColor">
                <path d="M542.22 32.05c-54.8 3.11-163.72 14.43-230.96 55.59-4.64 2.84-7.27 7.89-7.27 13.17v363.87c0 11.55 12.63 18.85 23.28 13.49 69.18-34.82 169.23-44.32 218.7-46.92 16.89-.89 30.02-14.43 30.02-30.66V62.75c.01-17.71-15.35-31.74-33.77-30.7zM264.73 87.64C197.5 46.48 88.58 35.17 33.78 32.05 15.36 31.01 0 45.04 0 62.75V400.6c0 16.24 13.13 29.78 30.02 30.66 49.49 2.6 149.59 12.11 218.77 46.95 10.62 5.35 23.21-1.94 23.21-13.46V100.63c0-5.29-2.62-10.14-7.27-12.99z" />
              </svg>
            </div>
            <h3 className="ny-highlight-title">Beginner Quran Classes </h3>
            <p className="ny-highlight-desc">
              Our online course for beginners includes students who are just beginning, whether kids or adults. We first start with Noorani Qaida, the Arabic alphabet, and its pronunciation. You will get trained on the basics of Quran reading by expert teachers. Students from across California can attend these classes online from their homes.
            </p>
          </div>

          {/* Card 2: Live Quran Classes */}
          <div className="ny-highlight-card">
            <div className="ny-highlight-icon-box">
              <svg className="ny-highlight-icon-svg" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm5.3-3c0 3-2.54 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z" />
              </svg>
            </div>
            <h3 className="ny-highlight-title">Quran Tajweed Classes</h3>
            <p className="ny-highlight-desc">
              If you wish to advance further in your Quran reading, our Tajweed Quran classes online will prove beneficial. Our online Quran classes with Tajweed in California improve the students’ reciting skills. By getting plenty of practice and top-notch training, students gain immense confidence and fluency in recitations.
            </p>
          </div>

          {/* Card 3: Male & Female Tutors */}
          <div className="ny-highlight-card">
            <div className="ny-highlight-icon-box">
              <svg className="ny-highlight-icon-svg" viewBox="0 0 640 512" fill="currentColor">
                <path d="M272 191.91c-17.6 0-32 14.4-32 32v80c0 8.84-7.16 16-16 16s-16-7.16-16-16v-76.55c0-17.39 4.72-34.47 13.69-49.39l77.75-129.59c9.09-15.16 4.19-34.81-10.97-43.91-14.45-8.67-32.72-4.3-42.3 9.21-.2.23-.62.21-.79.48l-117.26 175.9C117.56 205.9 112 224.31 112 243.29v80.23l-90.12 30.04A31.974 31.974 0 0 0 0 383.91v96c0 10.82 8.52 32 32 32 2.69 0 5.41-.34 8.06-1.03l179.19-46.62C269.16 449.99 304 403.8 304 351.91v-128c0-17.6-14.4-32-32-32zm346.12 161.73L528 323.6v-80.23c0-18.98-5.56-37.39-16.12-53.23L394.62 14.25c-.18-.27-.59-.24-.79-.48-9.58-13.51-27.85-17.88-42.3-9.21-15.16 9.09-20.06 28.75-10.97 43.91l77.75 129.59c8.97 14.92 13.69 32 13.69 49.39V304c0 8.84-7.16 16-16 16s-16-7.16-16-16v-80c0-17.6-14.4-32-32-32s-32 14.4-32 32v128c0 51.89 34.84 98.08 84.75 112.34l179.19 46.62c2.66.69 5.38 1.03 8.06 1.03 23.48 0 32-21.18 32-32v-96c0-13.77-8.81-25.99-21.88-30.35z" />
              </svg>
            </div>
            <h3 className="ny-highlight-title">Quran Memorization with Tajweed</h3>
            <p className="ny-highlight-desc">
              Check out our Quran memorization program with Tajweed lessons. Ideal for Quran learners, these advanced Hifz classes combine memory techniques with proper recitation methods. Students develop strong memorization skills while maintaining accurate recitation through proper Tajweed.
            </p>
          </div>
        </div>
      </section>

      <br />
      {/* Intro Info Section */}
      <section className="ny-intro-section">
        <div className="ny-intro-container">
          {/* Left Column: Text & CTA */}
          <div className="ny-intro-content">
            <h2 className="ny-intro-title">
              Learn Quran Online from the Best
              <span className="ny-intro-title--green"> Online Quran Academy in California
              </span>
            </h2>
            <p className="ny-intro-desc">
              Being one of the most trusted online Quran academies, we offer live Quran classes designed especially for kids and adults. The classes conducted by our experienced tutors aim to teach better Quran recitation, Tajweed, Hifz, and Islamic knowledge via one-on-one sessions. We serve all residents of California living in different cities, including, Los Angeles, San Francisco, San Diego, San Jose, Sacramento, Fresno, Oakland, Bakersfield, Anaheim, Santa Ana, Riverside, Stockton, Chula Vista, Irvine, Fremont, San Bernardino, Modesto, Fontana, Moreno Valley, Glendale, Huntington Beach, Santa Clarita, Garden Grove, Oceanside, Long Beach, Elk Grove, Corona, Rancho Cucamonga, Lancaster, Palmdale, Salinas, Pomona, Escondido, Sunnyvale, Torrance, Pasadena, and Orange.
            </p>
            <p className="ny-intro-desc">
              Just like our students in <a style={{ color: "#006100" }} href="/online-quran-classes-texas/"> Texas</a>, and <a style={{ color: "#006100" }} href="/online-quran-classes-in-newyork/">New York</a>, and throughout the USA, California students enjoy the same certified tutors and flexible scheduling.
            </p>
            <p className="ny-intro-desc">
              Our <a href="/free-trial/" style={{ color: "#006100" }}>free trial session</a> allows students and parents to meet their tutor, experience our teaching methodology, and receive a personalized learning assessment before enrollment.
            </p>
            <a href="/free-trial/" className="ny-intro-btn">

              Claim Your 3 Days Free Trial
            </a>
          </div>

          {/* Right Column: Image */}
          <div className="ny-intro-image-col">
            <img
              src={`${process.env.PUBLIC_URL}/assets/images/online-quran-classes-california/child.png`}
              alt="Learn Quran Online from the Best Online Quran Academy"
              className="ny-intro-img"
              style={{
                WebkitMaskImage: `url('${process.env.PUBLIC_URL}/assets/images/online-quran-classes-canada/masking.webp')`,
                WebkitMaskSize: 'contain',
                WebkitMaskPosition: 'center',
                WebkitMaskRepeat: 'no-repeat',
                maskImage: `url('${process.env.PUBLIC_URL}/assets/images/online-quran-classes-canada/masking.webp')`,
                maskSize: 'contain',
                maskPosition: 'center',
                maskRepeat: 'no-repeat'
              }}
            />
          </div>
        </div>
      </section>

      {/* Courses Offered Section */}
      <section className="ny-courses-section">
        <div className="ny-courses-container">
          <div className="ny-courses-header">
            <h2 className="ny-courses-badge">Courses Offered</h2>
            <h2 className="ny-courses-title">Online Quran Courses Available In California</h2>
            <div className="ny-courses-divider">
              <img
                src={`${process.env.PUBLIC_URL}/assets/images/pshape.png`}
                alt="Divider"
                className="ny-courses-divider-img"
              />
            </div>
          </div>

          <div className="ny-courses-grid">
            {/* Left Column: Image */}
            <div className="ny-courses-image-col">
              <img
                src={`${process.env.PUBLIC_URL}/assets/images/online-quran-classes-california/course-img.png`}
                alt="Online Quran Courses"
                className="ny-courses-img"
              />
            </div>

            {/* Right Column: Course list */}
            <div className="ny-courses-list">
              {/* Course 1 */}
              <a href="/quran-reading-classes-online-for-kids-and-adults/" className="ny-course-item" style={{ textDecoration: 'none' }}>
                <span className="ny-course-icon-box">
                  <svg aria-hidden="true" className="e-font-icon-svg e-fas-book-open" viewBox="0 0 576 512" xmlns="http://www.w3.org/2000/svg"><path d="M542.22 32.05c-54.8 3.11-163.72 14.43-230.96 55.59-4.64 2.84-7.27 7.89-7.27 13.17v363.87c0 11.55 12.63 18.85 23.28 13.49 69.18-34.82 169.23-44.32 218.7-46.92 16.89-.89 30.02-14.43 30.02-30.66V62.75c.01-17.71-15.35-31.74-33.77-30.7zM264.73 87.64C197.5 46.48 88.58 35.17 33.78 32.05 15.36 31.01 0 45.04 0 62.75V400.6c0 16.24 13.13 29.78 30.02 30.66 49.49 2.6 149.59 12.11 218.77 46.95 10.62 5.35 23.21-1.94 23.21-13.46V100.63c0-5.29-2.62-10.14-7.27-12.99z"></path></svg>
                </span>
                <h3 className="ny-course-text">Quran Reading Classes Online</h3>
              </a>

              {/* Course 2 */}
              <a href="/online-tajweed-classes-tajweed-course/" className="ny-course-item" style={{ textDecoration: 'none' }}>
                <span className="ny-course-icon-box">
                  <svg aria-hidden="true" className="e-font-icon-svg e-fas-praying-hands" viewBox="0 0 640 512" xmlns="http://www.w3.org/2000/svg"><path d="M272 191.91c-17.6 0-32 14.4-32 32v80c0 8.84-7.16 16-16 16s-16-7.16-16-16v-76.55c0-17.39 4.72-34.47 13.69-49.39l77.75-129.59c9.09-15.16 4.19-34.81-10.97-43.91-14.45-8.67-32.72-4.3-42.3 9.21-.2.23-.62.21-.79.48l-117.26 175.9C117.56 205.9 112 224.31 112 243.29v80.23l-90.12 30.04A31.974 31.974 0 0 0 0 383.91v96c0 10.82 8.52 32 32 32 2.69 0 5.41-.34 8.06-1.03l179.19-46.62C269.16 449.99 304 403.8 304 351.91v-128c0-17.6-14.4-32-32-32zm346.12 161.73L528 323.6v-80.23c0-18.98-5.56-37.39-16.12-53.23L394.62 14.25c-.18-.27-.59-.24-.79-.48-9.58-13.51-27.85-17.88-42.3-9.21-15.16 9.09-20.06 28.75-10.97 43.91l77.75 129.59c8.97 14.92 13.69 32 13.69 49.39V304c0 8.84-7.16 16-16 16s-16-7.16-16-16v-80c0-17.6-14.4-32-32-32s-32 14.4-32 32v128c0 51.89 34.84 98.08 84.75 112.34l179.19 46.62c2.66.69 5.38 1.03 8.06 1.03 23.48 0 32-21.18 32-32v-96c0-13.77-8.81-25.99-21.88-30.35z"></path></svg>
                </span>
                <h3 className="ny-course-text">Quran Tajweed Classes</h3>
              </a>

              {/* Course 3 */}
              <a href="/quran-memorization-classes-course/" className="ny-course-item" style={{ textDecoration: 'none' }}>
                <span className="ny-course-icon-box">
                  <svg aria-hidden="true" className="e-font-icon-svg e-fas-mosque" viewBox="0 0 640 512" xmlns="http://www.w3.org/2000/svg"><path d="M0 480c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V160H0v320zm579.16-192c17.86-17.39 28.84-37.34 28.84-58.91 0-52.86-41.79-93.79-87.92-122.9-41.94-26.47-80.63-57.77-111.96-96.22L400 0l-8.12 9.97c-31.33 38.45-70.01 69.76-111.96 96.22C233.79 135.3 192 176.23 192 229.09c0 21.57 10.98 41.52 28.84 58.91h358.32zM608 320H192c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h32v-64c0-17.67 14.33-32 32-32s32 14.33 32 32v64h64v-72c0-48 48-72 48-72s48 24 48 72v72h64v-64c0-17.67 14.33-32 32-32s32 14.33 32 32v64h32c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32zM64 0S0 32 0 96v32h128V96c0-64-64-96-64-96z"></path></svg>
                </span>
                <h3 className="ny-course-text">Quran Memorization Classes</h3>
              </a>

              {/* Course 4 */}
              <a href="/online-quran-translation-course/" className="ny-course-item" style={{ textDecoration: 'none' }}>
                <span className="ny-course-icon-box">
                  <svg aria-hidden="true" className="e-font-icon-svg e-fas-kaaba" viewBox="0 0 576 512" xmlns="http://www.w3.org/2000/svg"><path d="M554.12 83.51L318.36 4.93a95.962 95.962 0 0 0-60.71 0L21.88 83.51A32.006 32.006 0 0 0 0 113.87v49.01l265.02-79.51c15.03-4.5 30.92-4.5 45.98 0l265 79.51v-49.01c0-13.77-8.81-26-21.88-30.36zm-279.9 30.52L0 196.3v228.38c0 15 10.42 27.98 25.06 31.24l242.12 53.8a95.937 95.937 0 0 0 41.65 0l242.12-53.8c14.64-3.25 25.06-16.24 25.06-31.24V196.29l-274.2-82.26c-9.04-2.72-18.59-2.72-27.59 0zM128 230.11c0 3.61-2.41 6.77-5.89 7.72l-80 21.82C37.02 261.03 32 257.2 32 251.93v-16.58c0-3.61 2.41-6.77 5.89-7.72l80-21.82c5.09-1.39 10.11 2.44 10.11 7.72v16.58zm144-39.28c0 3.61-2.41 6.77-5.89 7.72l-96 26.18c-5.09 1.39-10.11-2.44-10.11-7.72v-16.58c0-3.61 2.41-6.77 5.89-7.72l96-26.18c5.09 1.39 10.11 2.44 10.11 7.72v16.58zm176 22.7c0-5.28 5.02-9.11 10.11-7.72l80 21.82c3.48.95 5.89 4.11 5.89 7.72v16.58c0 5.28-5.02 9.11-10.11 7.72l-80-21.82a7.997 7.997 0 0 1-5.89-7.72v-16.58zm-144-39.27c0-5.28 5.02-9.11 10.11-7.72l96 26.18c3.48.95 5.89 4.11 5.89 7.72v16.58c0 5.28-5.02 9.11-10.11 7.72l-96-26.18a7.997 7.997 0 0 1-5.89-7.72v-16.58z"></path></svg>
                </span>
                <h3 className="ny-course-text">Quran Translation Classes Online</h3>
              </a>
              <a href="/noorani-qaida-course/" className="ny-course-item" style={{ textDecoration: 'none' }}>
                <span className="ny-course-icon-box">
                  <svg aria-hidden="true" className="e-font-icon-svg e-fas-kaaba" viewBox="0 0 576 512" xmlns="http://www.w3.org/2000/svg"><path d="M554.12 83.51L318.36 4.93a95.962 95.962 0 0 0-60.71 0L21.88 83.51A32.006 32.006 0 0 0 0 113.87v49.01l265.02-79.51c15.03-4.5 30.92-4.5 45.98 0l265 79.51v-49.01c0-13.77-8.81-26-21.88-30.36zm-279.9 30.52L0 196.3v228.38c0 15 10.42 27.98 25.06 31.24l242.12 53.8a95.937 95.937 0 0 0 41.65 0l242.12-53.8c14.64-3.25 25.06-16.24 25.06-31.24V196.29l-274.2-82.26c-9.04-2.72-18.59-2.72-27.59 0zM128 230.11c0 3.61-2.41 6.77-5.89 7.72l-80 21.82C37.02 261.03 32 257.2 32 251.93v-16.58c0-3.61 2.41-6.77 5.89-7.72l80-21.82c5.09-1.39 10.11 2.44 10.11 7.72v16.58zm144-39.28c0 3.61-2.41 6.77-5.89 7.72l-96 26.18c-5.09 1.39-10.11-2.44-10.11-7.72v-16.58c0-3.61 2.41-6.77 5.89-7.72l96-26.18c5.09 1.39 10.11 2.44 10.11 7.72v16.58zm176 22.7c0-5.28 5.02-9.11 10.11-7.72l80 21.82c3.48.95 5.89 4.11 5.89 7.72v16.58c0 5.28-5.02 9.11-10.11 7.72l-80-21.82a7.997 7.997 0 0 1-5.89-7.72v-16.58zm-144-39.27c0-5.28 5.02-9.11 10.11-7.72l96 26.18c3.48.95 5.89 4.11 5.89 7.72v16.58c0 5.28-5.02 9.11-10.11 7.72l-96-26.18a7.997 7.997 0 0 1-5.89-7.72v-16.58z"></path></svg>
                </span>
                <h3 className="ny-course-text">Noorani Qaida Course</h3>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Section */}
      <section className="ny-why-section">
        <div className="ny-why-container">
          {/* Left Column: Text & CTA */}
          <div className="ny-why-content">
            <h2 className="ny-why-title">
              Why Thousands of California Families <span className="ny-why-title--green">Trust Al Quran Lesson</span>
            </h2>
            <p className="ny-why-desc">
              Finding the right online Quran academy in California can be overwhelming, but Al Quran Lesson offers something most academies simply don’t. We are more than just Quran classes. While most online Quran academies in California focus only on recitation, we go further. Alongside online Quran classes with Tajweed, Noorani Qaida course, Hifz, and Arabic Quran classes, we also offer Islamic Studies, daily Duas, and career-building programs for children, giving your child a complete Islamic foundation, not just Quran reading skills.
            </p>

            <a href="/free-trial/" className="ny-why-btn">
              Start Your 3-Day Free Trial
            </a>
          </div>

          {/* Right Column: Visual Stats Cards */}
          <div className="ny-why-stats-cards">
            {/* Card 1 */}
            <div className="ny-why-card-scroller">
              <div className="ny-why-card-icon-col">
                <span className="ny-why-card-icon-box">
                  <svg className="ny-why-card-icon" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M20 6h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .9-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-6 0h-4V4h4v2z" />
                  </svg>
                </span>
              </div>
              <div className="ny-why-card-content-col">
                <h3 className="ny-why-card-title">Technology-Enhanced Learning</h3>
                <p className="ny-why-card-desc">Our students don't just attend classes; they learn smarter. We provide soft notes, online PDFs, and structured digital learning materials that reinforce every lesson, making it easier for kids and adults to revise and retain what they learn.</p>
              </div>
            </div>

            {/* Card 2 */}
            <div className="ny-why-card-scroller">
              <div className="ny-why-card-icon-col">
                <span className="ny-why-card-icon-box">
                  <svg className="ny-why-card-icon" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" />
                  </svg>
                </span>
              </div>
              <div className="ny-why-card-content-col">
                <h3 className="ny-why-card-title">Ijazah-Certified Teachers with Islamic Specialization</h3>
                <p className="ny-why-card-desc">Every <a href="/our-tutors/" style={{ color: "#006100" }}>Quran tutor</a> at our academy holds an Ijazah from a recognized Islamic university with full specialization in their subject, whether Tajweed, Hifz, or Islamic Studies. This is not just a certificate; it is a chain of authentic Islamic knowledge passed down through generations.</p>
              </div>
            </div>

            {/* Card 3 */}
            <div className="ny-why-card-scroller">
              <div className="ny-why-card-icon-col">
                <span className="ny-why-card-icon-box">
                  <svg className="ny-why-card-icon" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 3L1 9l11 6 9-4.91V17h2V9L12 3zm0 18c-4.41 0-8-3.59-8-8c0-.62.08-1.21.21-1.79L9 15v-2.24l-3-2.14V7.57l6-3.43l6 3.43v3.05l-3 2.14V15l4.79-3.79c.13.58.21 1.17.21 1.79c0 4.41-3.59 8-8 8z" />
                  </svg>
                </span>
              </div>
              <div className="ny-why-card-content-col">
                <h3 className="ny-why-card-title">Affordable Pricing Without Compromising Quality</h3>
                <p className="ny-why-card-desc">We believe quality Islamic education should be accessible to every family. Our online Quran classes in California are priced lower than most competitors, so you never have to choose between quality and affordability.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* California Reviews Section */}
      <section className="tx-reviews-section" style={{ '--tx-reviews-bg': `url('${process.env.PUBLIC_URL}/assets/images/green-bg.png')` }}>
        <div className="tx-reviews-container">
          <div className="tx-reviews-header">
            <span className="tx-reviews-badge">Real Students, Real Results</span>
            <h2 className="tx-reviews-title">Student Reviews From California</h2>
            <p className="tx-reviews-subtitle">Don't Just Take Our Word For It, Here's What California Families Are Saying About Their Experience With Al Quran Lesson.</p>
          </div>
          <div className="tx-reviews-grid">
            {/* Review 1 */}
            <div className="tx-review-card">
              <span className="tx-quote-icon">“</span>
              <p className="tx-review-text">
                I've tried Al Quran Lesson for online Quran classes for my kids. As we are residing in California, with a busy schedule, we don't have enough time for his Quran study. My son studied for just 3 months, and his Quran reading improved significantly. The teachers are patient, professional, and supportive.
              </p>
              <div className="tx-review-footer">
                <div className="tx-review-author">
                  <span className="tx-author-name">Sarah Ahmed</span>
                  <span className="tx-author-sub">Parent From Los Angeles, California</span>
                </div>
                <span className="tx-review-tag">4 months</span>
              </div>
            </div>

            {/* Review 2 */}
            <div className="tx-review-card">
              <span className="tx-quote-icon">“</span>
              <p className="tx-review-text">
                Finding a reliable online Quran academy in California was tough until we found Al Quran Lesson. The teachers are punctual, polite, and very patient with my kids.
              </p>
              <div className="tx-review-footer">
                <div className="tx-review-author">
                  <span className="tx-author-name">Muhammad Ali</span>
                  <span className="tx-author-sub">Student From San Diego, California</span>
                </div>
                <span className="tx-review-tag">6 months</span>
              </div>
            </div>

            {/* Review 3 */}
            <div className="tx-review-card">
              <span className="tx-quote-icon">“</span>
              <p className="tx-review-text">
                The 1-on-1 focus really made a difference for my Tajweed recitation. I appreciate the female tutor availability and the overall quality of Islamic education.
              </p>
              <div className="tx-review-footer">
                <div className="tx-review-author">
                  <span className="tx-author-name">Ayesha Khan</span>
                  <span className="tx-author-sub">Parent from San Jose, California</span>
                </div>
                <span className="tx-review-tag">8 months</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Free Assessment/Trial Section */}
      <section className="free-assessment" id="free-trial">
        <div className="free-assessment__container">
          {/* Left Column: Info Text */}
          <div className="free-assessment__info">
            <div className="free-assessment__subtitle">
              <svg aria-hidden="true" className="free-assessment__subtitle-icon" viewBox="0 0 640 512" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 480c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V160H0v320zm579.16-192c17.86-17.39 28.84-37.34 28.84-58.91 0-52.86-41.79-93.79-87.92-122.9-41.94-26.47-80.63-57.77-111.96-96.22L400 0l-8.12 9.97c-31.33 38.45-70.01 69.76-111.96 96.22C233.79 135.3 192 176.23 192 229.09c0 21.57 10.98 41.52 28.84 58.91h358.32zM608 320H192c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h32v-64c0-17.67 14.33-32 32-32s32 14.33 32 32v64h64v-72c0-48 48-72 48-72s48 24 48 72v72h64v-64c0-17.67 14.33-32 32-32s32 14.33 32 32v64h32c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32zM64 0S0 32 0 96v32h128V96c0-64-64-96-64-96z" />
              </svg>
              <span>Apply For Free Registration</span>
            </div>

            <h2 className="free-assessment__title">
              Start Your Free Trial No Commitment Needed
            </h2>

            <p className="free-assessment__description">
              Our instructors will evaluate your current level of proficiency and create a customized plan for you, and you have the opportunity to try your first lesson without any fees using our free one-to-one online lessons in California.
            </p>

            <ul className="free-assessment__benefits">
              <li className="free-assessment__benefit-item">
                <svg className="free-assessment__check-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                </svg>
                <span>Experienced Tutors</span>
              </li>
              <li className="free-assessment__benefit-item">
                <svg className="free-assessment__check-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                </svg>
                <span>Flexible Hours</span>
              </li>
            </ul>

            <div className="free-assessment__contacts">
              <a href="tel:+17164577657" className="free-assessment__contact-item">
                <div className="free-assessment__contact-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="free-assessment__contact-svg">
                    <path d="M6.62 10.79a15.15 15.15 0 006.59 6.59l2.2-2.2a1 1 0 011.11-.27 11.72 11.72 0 003.7.59 1 1 0 011 1V20a1 1 0 01-1 1A17 17 0 013 4a1 1 0 011-1h3.5a1 1 0 011 1 11.72 11.72 0 00.59 3.7 1 1 0 01-.27 1.11z" />
                  </svg>
                </div>
                <div className="free-assessment__contact-text">
                  <span className="free-assessment__contact-label">Call Us Anytime</span>
                  <span className="free-assessment__contact-value">(716) 457-7657</span>
                </div>
              </a>

              <a href="mailto:info@alquranlesson.com" className="free-assessment__contact-item">
                <div className="free-assessment__contact-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="free-assessment__contact-svg">
                    <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
                  </svg>
                </div>
                <div className="free-assessment__contact-text">
                  <span className="free-assessment__contact-label">Email Us Anytime</span>
                  <span className="free-assessment__contact-value">info@alquranlesson.com</span>
                </div>
              </a>
            </div>
          </div>

          {/* Right Column: Registration Form */}
          <div
            className="free-assessment__form-container"
            style={{
              '--bg-url': `url('${process.env.PUBLIC_URL}/assets/images/green-bg.png')`
            }}
          >
            <form className="free-assessment__form" onSubmit={handleAssessmentSubmit}>
              <div className="free-assessment__form-row">
                <input
                  type="text"
                  name="firstName"
                  placeholder="First Name"
                  value={assessmentData.firstName}
                  onChange={handleAssessmentChange}
                  required
                  className="free-assessment__input"
                />
                <input
                  type="text"
                  name="lastName"
                  placeholder="Last Name"
                  value={assessmentData.lastName}
                  onChange={handleAssessmentChange}
                  required
                  className="free-assessment__input"
                />
              </div>

              <div className="free-assessment__form-row free-assessment__form-row--full">
                <select
                  name="course"
                  value={assessmentData.course}
                  onChange={handleAssessmentChange}
                  required
                  className="free-assessment__select"
                >
                  <option value="" disabled>Select Course</option>
                  <option value="Noorani Qaida">Noorani Qaida</option>
                  <option value="Quran Tajweed Classes">Quran Tajweed Classes</option>
                  <option value="Quran Reading Classes">Quran Reading Classes</option>
                  <option value="Quran Memorization Classes">Quran Memorization Classes</option>
                  <option value="Quran Translation Classes">Quran Translation Classes</option>
                </select>
              </div>

              <div className="free-assessment__form-row">
                <select
                  name="country"
                  value={assessmentData.country}
                  onChange={handleAssessmentChange}
                  required
                  className="free-assessment__select"
                >
                  <option value="" disabled>Select Country</option>
                  <option value="USA">USA</option>
                  <option value="UK">UK</option>
                  <option value="CA">CA</option>
                  <option value="Australia">Australia</option>
                  <option value="Other">Other</option>
                </select>
                <input
                  type="tel"
                  name="phone"
                  placeholder="Phone No"
                  value={assessmentData.phone}
                  onChange={handleAssessmentChange}
                  required
                  className="free-assessment__input"
                />
              </div>

              <div className="free-assessment__form-row free-assessment__form-row--full">
                <textarea
                  name="message"
                  placeholder="Message"
                  value={assessmentData.message}
                  onChange={handleAssessmentChange}
                  required
                  className="free-assessment__textarea"
                />
              </div>

              <button type="submit" className="free-assessment__submit-btn">
                Submit
              </button>
            </form>
          </div>
        </div>
      </section>

      {/* California Benefits Intro Banner */}
      <section className="tx-benefits-intro" style={{ '--tx-benefits-bg': `url('${process.env.PUBLIC_URL}/assets/images/Hero-4.jpg')` }}>
        <div className="tx-benefits-intro__container">
          <div className="tx-benefits-intro__badge">
            <svg aria-hidden="true" className="tx-benefits-intro__badge-icon" viewBox="0 0 640 512" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 480c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V160H0v320zm579.16-192c17.86-17.39 28.84-37.34 28.84-58.91 0-52.86-41.79-93.79-87.92-122.9-41.94-26.47-80.63-57.77-111.96-96.22L400 0l-8.12 9.97c-31.33 38.45-70.01 69.76-111.96 96.22C233.79 135.3 192 176.23 192 229.09c0 21.57 10.98 41.52 28.84 58.91h358.32zM608 320H192c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h32v-64c0-17.67 14.33-32 32-32s32 14.33 32 32v64h64v-72c0-48 48-72 48-72s48 24 48 72v72h64v-64c0-17.67 14.33-32 32-32s32 14.33 32 32v64h32c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32zM64 0S0 32 0 96v32h128V96c0-64-64-96-64-96z" fill="#005a2b" />
            </svg>
            <span>Benefits</span>
          </div>

          <h2 className="tx-benefits-intro__title">
            Benefits of Joining Our Online Quran Classes in California
          </h2>

          <p className="tx-benefits-intro__desc">
            At Al Quran Lesson, we ensure to provide the best online Quran classes in California with flexible and interactive classes for students of every age group. One-on-one tutoring ensures that you or your children get the opportunity to learn the Quran online with Tajweed in the comfort of your homes, guided by professional male and female Quran teachers. From Noorani Qaida to Quranic recitation and <a href="/quran-memorization-classes-course/" className="tx-benefits-intro__link">Quran memorization classes</a>, we provide everything to make Quran lessons easy and interesting.
          </p>
        </div>
      </section>



      {/* Certified Tutors Section */}
      <section className="certified-tutors" id="tutors">
        <div className="certified-tutors__container">
          {/* Headings */}
          <div className="certified-tutors__badge-wrapper">
            <span className="certified-tutors__badge">Expert Islamic Faculty</span>
          </div>
          <h2 className="certified-tutors__title">Meet Our Certified Tutors</h2>
          <p className="certified-tutors__subtitle">
            Every Tutor Is Personally Verified Certified, Experienced, And Background-Checked.
          </p>
          <div className="certified-tutors__title-underline"></div>

          {/* Content Layout */}
          <div className="certified-tutors__content">
            {/* Left Column: Features List */}
            <div className="certified-tutors__features">
              {/* Feature 1 */}
              <div className="certified-tutors__feature-item">
                <div className="certified-tutors__feature-icon-wrapper">
                  <svg className="certified-tutors__feature-icon" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 3L1 9l11 6 9-4.91V17h2V9L12 3zM5.47 12.5L12 16l6.53-3.56v3.06l-6.53 3.56-6.53-3.56v-3.06z" />
                  </svg>
                </div>
                <div className="certified-tutors__feature-text">
                  <h3 className="certified-tutors__feature-title">Hifzul Quran</h3>
                  <p className="certified-tutors__feature-desc">
                    Expert tutors graduated from Islamic University.
                  </p>
                </div>
              </div>

              {/* Feature 2 */}
              <div className="certified-tutors__feature-item">
                <div className="certified-tutors__feature-icon-wrapper">
                  <svg className="certified-tutors__feature-icon" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
                  </svg>
                </div>
                <div className="certified-tutors__feature-text">
                  <h3 className="certified-tutors__feature-title">Ijazah Holders</h3>
                  <p className="certified-tutors__feature-desc">
                    Authentic learning with connected Sanad.
                  </p>
                </div>
              </div>

              {/* Feature 3 */}
              <div className="certified-tutors__feature-item">
                <div className="certified-tutors__feature-icon-wrapper">
                  <svg className="certified-tutors__feature-icon" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                  </svg>
                </div>
                <div className="certified-tutors__feature-text">
                  <h3 className="certified-tutors__feature-title">Fluent English</h3>
                  <p className="certified-tutors__feature-desc">
                    Easy communication during Quran sessions.
                  </p>
                </div>
              </div>

              {/* Feature 4 */}
              <div className="certified-tutors__feature-item">
                <div className="certified-tutors__feature-icon-wrapper">
                  <svg className="certified-tutors__feature-icon" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2c-4.97 0-9 4.03-9 9 0 2.12.74 4.07 1.97 5.61L4.35 19.4c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0l2.79-2.79C10.09 18.66 11.02 19 12 19c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 15c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7z" />
                  </svg>
                </div>
                <div className="certified-tutors__feature-text">
                  <h3 className="certified-tutors__feature-title">Kids Specialists</h3>
                  <p className="certified-tutors__feature-desc">
                    Fun and patient teaching style for kids.
                  </p>
                </div>
              </div>
            </div>

            {/* Right Column: Swiper Carousel Slider */}
            <div className="certified-tutors__slider-container">
              <Swiper
                modules={[Pagination]}
                spaceBetween={30}
                grabCursor={true}
                pagination={{
                  clickable: true,
                  bulletClass: 'certified-tutors__pagination-bullet',
                  bulletActiveClass: 'certified-tutors__pagination-bullet--active'
                }}
                breakpoints={{
                  0: {
                    slidesPerView: 1.2,
                    spaceBetween: 20
                  },
                  576: {
                    slidesPerView: 1.8,
                    spaceBetween: 20
                  },
                  991: {
                    slidesPerView: 2.5,
                    spaceBetween: 30
                  }
                }}
                className="certified-tutors__swiper"
              >
                {tutorsData.map((tutor, index) => (
                  <SwiperSlide key={index}>
                    <div className="certified-tutors__card">
                      <div className="certified-tutors__card-image-wrapper">
                        <img
                          src={`${process.env.PUBLIC_URL}/assets/images/${tutor.image}`}
                          alt={tutor.name}
                          className="certified-tutors__card-img"
                        />
                      </div>
                      <div className="certified-tutors__card-content">
                        <h3 className="certified-tutors__card-name">{tutor.name}</h3>
                        <span className="certified-tutors__card-role">{tutor.role}</span>
                        <p className="certified-tutors__card-desc">{tutor.description}</p>
                        <a href={tutor.profileUrl} className="certified-tutors__card-btn">
                          View Profile
                        </a>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </div>
      </section>

      {/* California CTA Trial Section */}
      <section className="tx-cta-trial" style={{ '--tx-cta-bg': `url('${process.env.PUBLIC_URL}/assets/images/hero-bottom.webp')` }}>
        <div className="tx-cta-trial__container">
          {/* Left Column: Content */}
          <div className="tx-cta-trial__content">
            <h2 className="tx-cta-trial__title">
              Ready to Start Learning Quran? Claim Your 3-Day Free Trial Today!
            </h2>
            <div className="tx-cta-trial__underline"></div>
            <a href="/free-trial/" className="tx-cta-trial__btn">
              Book Your 3-Day Free Trial &rarr;
            </a>
          </div>

          {/* Right Column: Image */}
          <div className="tx-cta-trial__image-col">
            <img
              src={`${process.env.PUBLIC_URL}/assets/images/online-quran-classes-california/Img-.png`}
              alt="Get 3 Days Free Trial & Start Learning Online Quran With Tajweed!"
              className="tx-cta-trial__img"
            />
          </div>
        </div>
      </section>

      {/* California How It Works Section */}
      <div
        className="tx-how-it-works-wrapper"
        style={{
          '--bg-parallax': `url('${process.env.PUBLIC_URL}/assets/images/Hero-4.jpg')`
        }}
      >
        <section className="parallax-section how-it-works" id="how-it-works">
          <div className="parallax-section__container">
            <div className="how-it-works__badge">HOW IT WORKS</div>

            <h2 className="how-it-works__title">
              Start Online Quran Sessions In 3 Simple Steps
            </h2>

            <div className="how-it-works__steps-container">
              {/* Step 1 */}
              <div className="how-it-works__step">
                <div className="how-it-works__icon-wrapper">
                  <svg className="how-it-works__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
                  </svg>
                </div>
                <h3 className="how-it-works__step-num">Step 1</h3>
                <h4 className="how-it-works__step-title">Book Your Free 3-Day Trial</h4>
                <p className="how-it-works__step-desc">
                  You can easily and effortlessly set up using our online Quranic lessons! Reach out to our staff and get a no-obligation trial lesson, which will include an evaluation of your current Quran reading ability/skills, knowledge of Tajweed, and goals for future learning.


                </p>
              </div>

              {/* Step 2 */}
              <div className="how-it-works__step">
                <div className="how-it-works__icon-wrapper">
                  <svg className="how-it-works__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                  </svg>
                </div>
                <h3 className="how-it-works__step-num">Step 2</h3>
                <h4 className="how-it-works__step-title">Connect With Your Online Quran Tutor</h4>
                <p className="how-it-works__step-desc">
                  Once your evaluation is done, we will connect you with a specifically qualified and experienced Quran instructor who meets your specific needs. You get to pick between a certified male or female Quranic instructor based on your preference, ability to read and recite Qur’an, and previous experience.
                </p>
              </div>

              {/* Step 3 */}
              <div className="how-it-works__step">
                <div className="how-it-works__icon-wrapper">
                  <svg className="how-it-works__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                  </svg>
                </div>
                <h3 className="how-it-works__step-num">Step 3</h3>
                <h4 className="how-it-works__step-title">Start Your Quran Classes</h4>
                <p className="how-it-works__step-desc">
                  Once you have selected your tutor and set the dates for your classes, you can start learning the Holy Quran from your own comfortable home. We can provide you with individual lessons that could enhance your recitation skills of the Quran.
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* FAQs Section */}
      <section className="faq-section" id="faq">
        <div className="faq-section__container">
          <div className="faq-section__grid">
            {/* Left Column: Heading and Left Accordion FAQs */}
            <div className="faq-section__col faq-section__col--left">
              <h2 className="faq-section__title">Frequently Asked Questions</h2>
              <p className="faq-section__subtitle">
                Look, we know choosing online Quran education is a big decision. You might have questions. Here's what most people ask us.
              </p>

              <div className="faq-section__accordion">
                {CaliforniaLeftFAQs.map((faq) => (
                  <div key={faq.id} className={`faq-item ${openFaqId === faq.id ? 'faq-item--open' : ''}`}>
                    <button
                      className="faq-item__header"
                      onClick={() => toggleCaliforniaFAQ(faq.id)}
                      aria-expanded={openFaqId === faq.id}
                    >
                      <span>{faq.question}</span>
                      <svg className="faq-item__icon" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clipRule="evenodd" />
                      </svg>
                    </button>
                    <div className="faq-item__body">
                      <div className="faq-item__content">
                        <p>{faq.answer}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Right Column: Right Accordion FAQs */}
            <div className="faq-section__col faq-section__col--right">
              <div className="faq-section__accordion">
                {CaliforniaRightFAQs.map((faq) => (
                  <div key={faq.id} className={`faq-item ${openFaqId === faq.id ? 'faq-item--open' : ''}`}>
                    <button
                      className="faq-item__header"
                      onClick={() => toggleCaliforniaFAQ(faq.id)}
                      aria-expanded={openFaqId === faq.id}
                    >
                      <span>{faq.question}</span>
                      <svg className="faq-item__icon" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clipRule="evenodd" />
                      </svg>
                    </button>
                    <div className="faq-item__body">
                      <div className="faq-item__content">
                        <p>{faq.answer}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Calendly Consultation & Contact Info Section */}
      <section
        className="consultation-section"
        id="consultation"
        style={{
          '--bg-url': `url('${process.env.PUBLIC_URL}/assets/images/online-quran-classes-california/edb9b1a643ea3ab6044ffcbbb4fe0032.png')`
        }}
      >
        <div className="consultation-section__container">
          {/* Header Block */}
          <div className="consultation-section__header">
            <h2 className="consultation-section__title">
              Let's Talk About Your Quran Classes Online
            </h2>
            <div className="consultation-section__subtitle">
              Tell us about your learning objectives so that we can associate you with the right tutor. Fill out the form below. Our online Quran classes team reaches out to schedule your free trial sessions.
            </div>
          </div>

          {/* Content Columns */}
          <div className="consultation-section__grid">
            {/* Left Column: Calendly widget */}
            <div className="consultation-section__widget-container">
              <div
                className="calendly-inline-widget"
                data-url="https://calendly.com/alquranlesson/call-consultation"
                style={{ minWidth: '320px', height: '700px' }}
              />
            </div>

            {/* Right Column: Contact Info list */}
            <div className="consultation-section__info">
              <h3 className="consultation-section__info-title">CONTACT INFO</h3>

              <ul className="consultation-section__list">
                <li className="consultation-section__item">
                  <div className="consultation-section__icon-wrapper">
                    <svg className="consultation-section__icon" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                      <path strokeLinecap="round" strokeLinejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                  </div>
                  <a href="https://maps.google.com/?q=Mississauga,+Ontario,+L5K,+1W2" target="_blank" rel="noopener noreferrer" className="consultation-section__link">
                    Mississauga, Ontario, L5K, 1W2
                  </a>
                </li>

                <li className="consultation-section__item">
                  <div className="consultation-section__icon-wrapper">
                    <svg className="consultation-section__icon" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                      <path strokeLinecap="round" strokeLinejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                  </div>
                  <a href="https://maps.google.com/?q=1942+BROADWAY+ST+STE+314C,+80302,+BOULDER,+United+States" target="_blank" rel="noopener noreferrer" className="consultation-section__link">
                    1942 BROADWAY ST STE 314C, 80302, BOULDER, United States
                  </a>
                </li>

                <li className="consultation-section__item">
                  <div className="consultation-section__icon-wrapper">
                    <svg className="consultation-section__icon" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.94.725l.548 2.2a1 1 0 01-.321.988l-1.305.98a10.582 10.582 0 004.872 4.872l.98-1.305a1 1 0 01.988-.321l2.2.548a1 1 0 01.725.94V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                    </svg>
                  </div>
                  <a href="tel:+16477385707" className="consultation-section__link">+1 647 738 5707 (Canada)</a>
                </li>

                <li className="consultation-section__item">
                  <div className="consultation-section__icon-wrapper consultation-section__icon-wrapper--whatsapp">
                    <FaWhatsapp className="consultation-section__icon" />
                  </div>
                  <a href="https://wa.me/17164577657" target="_blank" rel="noopener noreferrer" className="consultation-section__link">716-457-7657</a>
                </li>

                <li className="consultation-section__item">
                  <div className="consultation-section__icon-wrapper">
                    <svg className="consultation-section__icon" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.94.725l.548 2.2a1 1 0 01-.321.988l-1.305.98a10.582 10.582 0 004.872 4.872l.98-1.305a1 1 0 01.988-.321l2.2.548a1 1 0 01.725.94V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                    </svg>
                  </div>
                  <a href="tel:+17164577657" className="consultation-section__link">+1 716 457 7657 (USA)</a>
                </li>

                <li className="consultation-section__item">
                  <div className="consultation-section__icon-wrapper">
                    <svg className="consultation-section__icon" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.94.725l.548 2.2a1 1 0 01-.321.988l-1.305.98a10.582 10.582 0 004.872 4.872l.98-1.305a1 1 0 01.988-.321l2.2.548a1 1 0 01.725.94V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                    </svg>
                  </div>
                  <a href="tel:+447441394281" className="consultation-section__link">+44 7441 394281 (UK)</a>
                </li>

                <li className="consultation-section__item">
                  <div className="consultation-section__icon-wrapper">
                    <svg className="consultation-section__icon" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                  </div>
                  <a href="mailto:info@alquranlesson.com" className="consultation-section__link">info@alquranlesson.com</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default OnlineQuranClassesCalifornia;

